export const initialState = {
  dark: true,
  width: null,
  height:null,
  pushOut:false,
  submenu: null,
};
